import Button from "../../design/Button";
import GModal from "../../design/components/GModal";
import {
  alertTriangleIcon,
  callRecordingGHeaderCopyIcon as copyIcon,
} from "../../../utility-functions/assetLoader";
import { enqueueSnackbar } from "notistack";
import classes from "./CopyApiKeyModal.module.css";

const CopyApiKeyModal = ({ visible, onClose, apiKey }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(apiKey);
    enqueueSnackbar("API key copied to clipboard", { variant: "success" });
  };

  return (
    <GModal
      visible={visible}
      closeModal={onClose}
      heading="Your API key"
      modalStyle={{ width: "440px" }}
      bottomButtonsStyle={{ border: "none", paddingTop: 0 }}
      bodyWrapperStyle={{ paddingRight: 0 }}
      noScrollbar={true}
      bottomButtons={[
        <Button
          buttonText="Copy and close"
          hierarchy="green"
          variant="contained"
          onClick={() => {
            handleCopy();
            onClose();
          }}
        />,
      ]}
      body={
        <div className={classes.container}>
          <div className={classes.warningContainer}>
            <span>{alertTriangleIcon("#CC7629", "20px", "26px")}</span>
            <p className="t7 regular-font">
              This is the only time this key will be displayed. Make sure to
              copy and store it securely.
            </p>
          </div>
          <div>
            <label className="t7 medium-font nc-gray-900">API key</label>
            <div className={classes.apiKeyContainer}>
              <input
                value={apiKey}
                readOnly
                className="t7 regular-font nc-gray-900"
              />
              <button
                className={`${classes.copyButton} t7 regular-font nc-gray-900`}
                onClick={handleCopy}
              >
                {copyIcon("#70707B", 20, 20)}
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

export default CopyApiKeyModal;
